module.exports = __webpack_public_path__ + "media/images/Cata-3-5b638891b76dafa6870f6832d79fd4d6.jpg";